var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-scope relative ml-8 flex h-[160px] pt-2"},_vm._l((_vm.loadingArray),function(x,index){return _c('BarChartLoadingItem',{key:'loading-' + x.key,attrs:{"index":index,"value":x.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }